import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLock"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C9.79086 2 8 3.79086 8 6V9H6.5C5.11929 9 4 10.1193 4 11.5V19.5C4 20.8807 5.11929 22 6.5 22H17.5C18.8807 22 20 20.8807 20 19.5V11.5C20 10.1193 18.8807 9 17.5 9H16V6C16 3.79086 14.2091 2 12 2ZM15 9V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V9H15ZM12 13.5C12.2761 13.5 12.5 13.7239 12.5 14V17C12.5 17.2761 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.2761 11.5 17V14C11.5 13.7239 11.7239 13.5 12 13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLock;
